import { APP_BASE_HREF } from '@angular/common';
import { Canal, ContextService, CustomWindow } from '@bcef/ia-shared';
import { WA_WINDOW } from '@ng-web-apis/common';

export const environment = {
  production: true,
  providers: [
    {
      provide: APP_BASE_HREF,
      useFactory: (window: CustomWindow, context: ContextService): string | void => {
        if (window.APPS_BASE_HREF && window.CANAL === Canal.DESKTOP) {
          return window.APPS_BASE_HREF;
        } else {
          // Temporary fix for webview
          window.document.body.classList.add(context.typology);
          return `${window.APPS_BASE_HREF}.html`;
        }
      },
      deps: [WA_WINDOW, ContextService],
    },
  ],
};
